/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from 'react';
import { withStyles } from '@material-ui/core/styles';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import { Context as HeaderFooterContext } from '../../../shared/context/Assets-Context';
import { NavLink } from 'react-router-dom';

const Accordion = withStyles({
    root: {
        border: '1px solid rgba(0, 0, 0, .125)',
        boxShadow: 'none',
        '&:not(:last-child)': {
            borderBottom: 0,
        },
        '&:before': {
            display: 'none',
        },
        '&$expanded': {
            margin: 'auto',
        },
    },
    expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
    root: {
        backgroundColor: 'rgba(0, 0, 0, .03)',
        borderBottom: '1px solid rgba(0, 0, 0, .125)',
        marginBottom: -1,
        minHeight: 56,
        '&$expanded': {
            minHeight: 56,
        },
    },
    content: {
        '&$expanded': {
            margin: '12px 0',
        },
    },
    expanded: {},
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiAccordionDetails);



const SideNav = props => {

    const { state } = useContext(HeaderFooterContext);
    const footerAssets = state.headerFooterContent;
    let apiOptions = [];
    if (footerAssets) {

        apiOptions = footerAssets.api_options.map((obj) => {
            return {
                title: obj.api_link.title,
                hasChild: obj.api_child ? true : false,
                path: (obj.api_link.title === "Pagrindinis" || obj.api_link.title === "Home") ? "" : obj.api_link.title.toLowerCase().replaceAll(" ", "-"),
                url: obj.api_link.url,
                childs: obj.api_child ? obj.api_child.map(child => {
                    return {
                        title: child.api_child_link.title,
                        path: child.api_child_link.title.toLowerCase().replaceAll(" ", "-"),
                        url: child.api_child_link.url
                    };
                }) : []
            };
        });
    }
    const [expanded, setExpanded] = useState(`panel-${0}`);
    useEffect(() => {
        handMenuHeightOnClick();
        setMobileMenu();
        if(window.innerWidth > 1200){
            setExpanded(`panel-${apiOptions.findIndex(ob => ob.path.includes(props.currentPath))}`);
        }
    }, [footerAssets]);

    const setMobileMenu = () => {
        setTimeout(() => {
            if (window.innerWidth < 1200) {
                if (props.topId !== 'apiWrap') {
                    const header = document.getElementById("siteHeader");
                    const mobilesidenav = document.getElementById("mobilesidenav");
                    const documentationWrap = document.getElementById(props.topId);
                    if (header && mobilesidenav && documentationWrap) {
                        mobilesidenav.style.top = `${header.clientHeight}px`;
                        documentationWrap.style.paddingTop = `${mobilesidenav.clientHeight}px`;
                    }
                }
            }
        }, 105);
    };

    const handMenuHeightOnClick = () => {
        const sideNav = document.getElementById("side-nav");
        const sideNavClone = document.getElementById("side-nav-clone");
        if (sideNav && sideNavClone) {
            setTimeout(() => {
                const expandedUL = document.getElementsByClassName("isOpen")[0];
                if (expandedUL) {
                    sideNavClone.style.height = `${window.innerWidth > 1200 ? sideNav.clientHeight : expandedUL.clientHeight}px`;
                } else {
                    sideNavClone.style.height = `${window.innerWidth > 1200 ? sideNav.clientHeight : 0}px`;
                }
                sideNavClone.style.transition = '0.1s ease-in';
                setMobileMenu();
            }, 102);
        }
    };
    /**
     * handleChange is used to open main panel
     * this is used to open drop down menu on mobile and tab view
     * @param {*} panel 
     */
    const handleChange = (panel) => {
        setExpanded(expanded === panel ? '' : panel);
        handMenuHeightOnClick();
    };
    return (
        <>
            <div className="nav-wrap">
                <div className={ `side-nav` } id="side-nav">
                    {
                        !!apiOptions.length && apiOptions.map((obj, index) => {
                            return (

                                <Accordion className={`${!obj.hasChild ? 'no-child' : ''}`} square expanded={ expanded === `panel-${index}` } key={ index } TransitionProps={ {
                                    timeout: {
                                        appear: 100,
                                        enter: 100,
                                        exit: 100
                                    }
                                } } >
                                    <AccordionSummary
                                        onClick={ () => obj.hasChild && handleChange(`panel-${index}`) }
                                        className={ props.summaryClassName }
                                        aria-controls={ `panel${index}-content` }
                                        IconButtonProps={ { onClick: () => obj.hasChild && handleChange(`panel-${index}`) } }
                                        id={ `panel${index}-header` }
                                        expandIcon={ obj.hasChild && props.expandIcon }

                                    >
                                        {
                                            !obj.hasChild && <NavLink to={ `/api/${obj.path}?${obj.url}` } activeClassName="isCurrent">{ obj.title }</NavLink>
                                        }
                                        {
                                            obj.hasChild && <p className={ `${expanded === `panel-${index}` ? 'isCurrent' : ''}` }>
                                                { obj.title }
                                            </p>
                                        }


                                    </AccordionSummary>
                                    <AccordionDetails className={ props.detailClassName }>
                                        <ul className={ `${expanded === `panel-${index}` ? 'isOpen' : ''}` }>
                                            {
                                                obj.hasChild && !!obj.childs.length && obj.childs.map((child, childIndex) => {
                                                    return (
                                                        <li key={ childIndex }>
                                                            <NavLink
                                                                to={ `/api/${obj.path}/${child.path}?${child.url}` }
                                                                activeClassName="isCurrent"
                                                                onClick={ () => {
                                                                    if (window.innerWidth < 1200) {
                                                                        setExpanded('');
                                                                        handMenuHeightOnClick();
                                                                    }
                                                                } }
                                                            >{ child.title }
                                                            </NavLink>
                                                        </li>
                                                    );
                                                })
                                            }
                                        </ul>
                                    </AccordionDetails>
                                </Accordion>
                            );
                        })
                    }
                </div>
                <div className="side-nav-clone" id="side-nav-clone"></div>
            </div>
        </>
    );
};

export default SideNav;